<template>
  <div>
    <div class="main-content">
      <div class="row">
        <div class="col-12 col-md-6">
          <h2>Data Table</h2>
        </div>
        <div class="col-12 col-md-6">
          <div class="rating-container float-md-right mb-3">
            <RateCapability :qAppId="qAppIdRatingValue"></RateCapability>
          </div>
        </div>
      </div>
      <br />
      <div class="row mb-3">
        <div class="col-xs-12 col-sm-6 col-md-6">
          <h4>Filters</h4>
          <div class="row">
            <div class="col-xs-12 col-sm-6 col-md-6">
              <div
                class="q-filter horizontal noHeader"
                id="HxyBY"
              ></div>
            </div>
            <div class="col-xs-12 col-sm-6 col-md-6">
              <div
                class="q-filter horizontal noHeader"
                id="npGTZM"
              ></div>
            </div>
            <div class="col-xs-12 col-sm-6 col-md-6">
              <div
                class="q-filter horizontal noHeader"
                id="sPC"
              ></div>
            </div>
            <div class="col-xs-12 col-sm-6 col-md-6">
              <div class="q-filter horizontal noHeader" id="xzun"></div>
            </div>
            <div class="col-xs-12 col-sm-6 col-md-6">
              <div
                class="q-filter horizontal noHeader"
                id="bmQPJvt"
              ></div>
            </div>
          </div>
        </div>
        <div class="col-xs-12 col-sm-6 col-md-6">
          <h4>View As</h4>
          <div class="row">
            <div class="col-xs-12 col-sm-5 col-md-4">
              <div class="q-filter noHeader" id="TnXWjK"></div>
            </div>
            <div class="col-xs-12 col-sm-5 col-md-4">
              <div class="q-filter noHeader" id="pRXXPh"></div>
            </div>
            <div class="col-xs-12 col-sm-5 col-md-4">
              <div class="q-filter noHeader" id="RepjESF"></div>
            </div>
          </div>
          <div class="col-xs-12">
              <p class="alert alert-info">Cum. Forecast = Sales of closed Quarters + Forecast CQ</p>
          </div>
        </div>
      </div>
      <div class="row one-viz-row h600">
        <div class="col-12">
          <QlikViz vizId="pPppruJ" vizTitle=""/>
        </div>
      </div>
    </div>
  </div>
</template>
<style>
</style>
<script>
import qAPI from "../../../services/qAPI";
import page from "../../../mixins/page";

export default {
  name: "ForecastDataTable",
  props: [],
  mixins: [page],
  components: {},
  data() {
    return {
      pageName: this.$route.name,
      mashup: null,
      qObjects:
        "HxyBY,npGTZM,sPC,bmQPJvt,xzun,TnXWjK,pRXXPh,RepjESF,pPppruJ",
      qFilterObjects: [
        {
          id: "baPMyn",
          nFilters: 4,
        },
        {
          id: "BwAMSs",
          nFilters: 5,
        },
        {
          id: "DuqNp",
          nFilters: 1,
        },
        {
          id: "cbvR",
          nFilters: 2,
        }
      ],
    };
  },
  async mounted() {
    await this.init(this.$route, this.qObjects, this.qFilterObjects);
  },
  async destroyed() {
    qAPI.closeQlikObjectsInStore(this.qObjects.split(","));
  }
};
</script>
